import { Card, Button, message, Modal } from "antd";
import { useState } from "react";
import { Steps } from "antd";
import { generateToken } from "../service/generateToken";
import { getTrackingDetail } from "../service/getTrackingDetail";
import { Alert } from "antd";

const { Step } = Steps;

const getColorPaymentStatus = (status) => {
  if (status === "จ่ายเต็ม") {
    return "#7cb305";
  } else if (status === "ยังไม่จ่าย") {
    return "#cf1322";
  } else if (status === "มัดจำ") {
    return "#faad14";
  } else {
    return "#8c8c8c";
  }
};

const getColorItenStatus = (status) => {
  if (status === "รอกด") {
    // ส้ม
    return "#fa8c16";
  } else if (status === "กดแล้ว") {
    return "#52c41a";
  } else if (status === "ถึงบ้านเกา") {
    return "#1890ff";
  } else if (status === "ถึงไทยแล้ว") {
    return "#722ed1";
  } else if (status === "กำลังแพ็ค") {
    return "#eb2f96";
  } else if (status === "จัดส่งแล้ว") {
    return "#52c41a";
  } else if (status === "เว็บยกเลิก") {
    return "#f5222d";
  } else if (status === "ลูกค้ายกเลิก") {
    return "#f5222d";
  }
};
const ListItem = (props) => {
  const [isModal, setIsModal] = useState(false);
  const [trackDetail, setTrackDetail] = useState(null);
  const [loadTracking, setLoadTracking] = useState(false);
  const [, setErrorTracking] = useState(false);
  const [errorTrackingMsg, setErrorTrackingMsg] = useState(null);

  const copyTrackNo = (trackNo) => {
    navigator.clipboard.writeText(trackNo);
    message.success("Copy Tracking No. Success");
  };

  const openModal = async (trackNo) => {
    if (trackNo.substring(11, 13) === "TH") {
      setIsModal(true);
      setLoadTracking(true);
      const token = await generateToken();
      if (token.status) {
        const trackingDetail = await getTrackingDetail(token.token, trackNo);
        if (trackingDetail.status) {
          setTrackDetail(trackingDetail.response.items[trackNo]);
        } else {
          setErrorTracking(true);
          setErrorTrackingMsg({
            msg: "Something Went Wrong , Please Try Again Later",
            code: trackingDetail.code,
          });
        }
      } else {
        setErrorTracking(true);
        setErrorTrackingMsg({
          msg: "Something Went Wrong , Please Try Again Later",
          code: token.code,
        });
      }
      setLoadTracking(false);
    } else {
      window.open(
        `https://www.jtexpress.co.th/service/track?waybillNo=${trackNo}&pageType=index`,
        "_blank",
        "noopener,noreferrer"
      );
    }
  };

  const handleCancel = () => {
    setErrorTracking(false);
    setErrorTrackingMsg(null);
    setIsModal(false);
  };

  //   const getTrackkingNo = (tracking_no) => {
  //     if (tracking_no === null || tracking_no === "") {
  //       return [];
  //     }
  //     let trackList = tracking_no.split(",");
  //     let trackData = [];
  //     if (trackList.length > 0) {
  //       for (let i = 0; i <= trackList.length; i++) {
  //         if (
  //           trackList[i]?.length === 13 &&
  //           trackList[i]?.charAt(11) === "T" &&
  //           trackList[i]?.charAt(12) === "H"
  //         ) {
  //           trackData.push(trackList[i]);
  //         }
  //       }
  //       return trackData;
  //     } else {
  //       return [];
  //     }
  //   };

  const item = props.data;
  return (
    <div style={{ display: "flex", justifyContent: "center", padding: 10 }}>
      {/* <Badge.Ribbon text={item.product_status}> */}
      <Card style={{ width: 320 }}>
        <div>
          <span style={{ fontSize: 16 }}>
            {item.product_name ? item.product_name.substring(0, 50) : "-"}
            {item.product_name
              ? item.product_name.length > 50
                ? "..."
                : ""
              : "-"}
          </span>
          <br></br>
          <small>จำนวน : {item.amount || "-"}</small>
          <br></br>
          <small>
            สถานะสินค้า :{" "}
            <span
              style={{
                border: `1px solid ${getColorItenStatus(item.product_status)}`,
                color: `${getColorItenStatus(item.product_status)}`,
                padding: "3px 7px",
                borderRadius: 6,
              }}
            >
              {item.product_status || "-"}{" "}
            </span>
          </small>
          <br></br>
          <small>การจัดส่ง : {item.payment_method || "-"}</small>
          <br></br>
          <small>
            สถานะการจ่ายเงิน :{" "}
            <span
              style={{
                backgroundColor: getColorPaymentStatus(item.payment_status),
                padding: "3px 7px",
                color: "white",
                borderRadius: 6,
              }}
            >
              {item.payment_status || "-"}{" "}
            </span>
          </small>
        </div>
        <div
          style={{
            marginTop: 10,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {item && item.tracking_no && (
            <div>
              <div>{item.tracking_no}</div>
              <div style={{ display: "flex" }}>
                <Button
                  type="primary"
                  size={"small"}
                  onClick={() => copyTrackNo(item.tracking_no)}
                  style={{ marginRight: 5 }}
                  disabled={
                    item.tracking_no === null || item.tracking_no === ""
                  }
                >
                  Copy
                </Button>
                <Button
                  type="secondary"
                  size={"small"}
                  onClick={() => openModal(item.tracking_no)}
                  disabled={
                    item.tracking_no === null || item.tracking_no === ""
                  }
                >
                  Tracking
                </Button>
              </div>
            </div>
          )}
        </div>
      </Card>
      {/* </Badge.Ribbon> */}
      <Modal
        title="Tracking Status"
        visible={isModal}
        onCancel={handleCancel}
        footer={null}
      >
        {loadTracking && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <img
              src={process.env.PUBLIC_URL + "/loading.svg"}
              alt="loading"
              style={{ width: "5rem" }}
            />
          </div>
        )}

        {trackDetail && trackDetail.length > 0 && (
          <Steps
            progressDot
            current={trackDetail && trackDetail.length}
            direction="vertical"
          >
            {/* <QueueAnim duration={1000}> */}
            {trackDetail &&
              trackDetail.map((item, i) => {
                return (
                  <Step
                    key={i}
                    title={`${item.status_description} : ${item.location}  `}
                    description={item.status_date}
                  />
                );
              })}
            {/* </QueueAnim> */}
          </Steps>
        )}
        {trackDetail && trackDetail.length === 0 && (
          <Alert
            message="Data not found"
            description="เลข Tracking นี้ยังไม่ถูกนำเข้าระบบ"
            type="warning"
            showIcon
          />
        )}
        {errorTrackingMsg && (
          <Alert
            message={`Error ${errorTrackingMsg.code}`}
            description={errorTrackingMsg.msg}
            type="error"
            showIcon
          />
        )}
      </Modal>
    </div>
  );
};

export default ListItem;
